<template>
    <v-container>
        <v-card>
            <v-card-title class="light-blue lighten-3">Fase de Higienización {{idHigienizacion}}</v-card-title>
            <v-row class="ma-2 blue-grey lighten-5">
                <v-col md="10">
                    Umbral temperatura: 
                </v-col>
                <v-icon>mdi-thermometer</v-icon>
                <v-col class="red--text"> <hmi-editable-number-input :valor="higienizacion.temperaturaUmbral" unidades=" ºC" @cambio="actualizarTemperatura"></hmi-editable-number-input> </v-col>
            </v-row>
            <v-row class="ma-2">
                <v-col md="10">
                    Tiempo maximo en temperatura umbral: 
                </v-col>
                <v-icon>mdi-timer-outline</v-icon>
                <v-col> <hmi-editable-number-input :valor="segundosAMinutos(higienizacion.tiempoUmbral)" unidades=" mins" @cambio="actualizarTiempo"></hmi-editable-number-input> </v-col>
            </v-row>
        </v-card>
    </v-container>
</template>
<script>
import HmiEditableNumberInput from '@/components/HMI/modulos/HmiEditableNumberInput.vue'
import {mapState, mapActions} from 'vuex'
export default {
    props:{
        idHigienizacion: String,
        temperaturaUmbral: {type: [String, Number]},
        tiempoUmbral: {type: [String, Number]},
    },
    components: {
        HmiEditableNumberInput
    },
    computed: {
        ...mapState("eggnovo",[
            'higienizacion1',
            'higienizacion2',
        ]),
        higienizacion(){
            let result = (this.idHigienizacion == '1') ? this.higienizacion1 : this.higienizacion2
            return result
        }
    },
    data() {
        return {
            
        }
    },
    methods: {
        ...mapActions("eggnovo",[
            'set_temp_umbral_hig1',
            'set_temp_umbral_hig2',
            'set_tiempo_umbral_hig1',
            'set_tiempo_umbral_hig2',
        ]),
        actualizarTemperatura(payload){ //Solo sirve para mostrar
            let result = (this.idHigienizacion == '1') ? this.set_temp_umbral_hig1(payload.valor) : this.set_temp_umbral_hig2(payload.valor)
            this.$emit('cambio')
        },
        actualizarTiempo(payload){//Usuario introduce en minutos pero nosotros guardamos en segundos
            let result = (this.idHigienizacion == '1') ? this.set_tiempo_umbral_hig1(payload.valor*60) : this.set_tiempo_umbral_hig2(payload.valor*60)
            this.$emit('cambio')
        },
        segundosAMinutos(segundos){
            return Math.round(segundos/60) //Redondeo a minutos exactos
        },
    }
}
</script>
<style>
    
</style>